import React from 'react';

/**
 * Componente de input que solo permite números enteros
 * @param {object} props - Propiedades del componente
 * @param {string|number} props.value - Valor actual del input
 * @param {function} props.onChange - Función a llamar cuando cambia el valor
 * @param {string} props.name - Nombre del campo (para formularios)
 * @param {string} props.placeholder - Texto de placeholder
 * @param {string} props.className - Clases CSS adicionales
 * @param {object} props.validation - Reglas de validación {min, max, errorMsg}
 * @returns {JSX.Element} - Componente de input para números enteros
 */
function IntegerInput({ 
  value, 
  onChange, 
  name, 
  placeholder, 
  className = "", 
  validation = {},
  ...props 
}) {
  const handleChange = (e) => {
    // Eliminar cualquier caracter que no sea dígito
    const sanitizedValue = e.target.value.replace(/[^\d]/g, '');
    
    // Crear un evento sintético con el valor sanitizado
    const syntheticEvent = { 
      ...e, 
      target: { 
        ...e.target, 
        value: sanitizedValue,
        name: name 
      } 
    };
    
    // Llamar al onChange con el evento modificado
    onChange(syntheticEvent);
  };

  // Verificar si hay error de validación
  const hasError = () => {
    if (!validation || !validation.rules) return false;
    
    const numValue = parseInt(value) || 0;
    
    // Verificar reglas de validación
    if (validation.rules.min !== undefined && numValue < validation.rules.min) return true;
    if (validation.rules.max !== undefined && numValue > validation.rules.max) return true;
    if (validation.rules.compare && typeof validation.rules.compare === 'function') {
      return validation.rules.compare(numValue);
    }
    
    return false;
  };

  const errorMessage = hasError() && validation.errorMsg ? validation.errorMsg : '';
  
  return (
    <>
      <input
        type="text"
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder || "Ingrese un número"}
        className={`${className} ${errorMessage ? 'border-red-500' : ''}`}
        {...props}
      />
      {errorMessage && (
        <div className="text-xs text-red-500 mt-1">
          {errorMessage}
        </div>
      )}
    </>
  );
}

export default IntegerInput;